<template>
  <div class="publicsolicitation">
    <div id="header">
      <div class="logo">
        <img src="../assets/omi-logo.svg" alt="OMI-LOGO" />
      </div>
      <div id="mediums">
        <input id="instagram" name="tab_item" type="radio" checked />
        <label class="instagram tab_item" for="instagram" @click="changeSns(0)"
          >Instagram</label
        >
        <input id="tiktok" name="tab_item" type="radio" />
        <label class="tiktok tab_item" for="tiktok" @click="changeSns(1)"
          >TikTok</label
        >
        <input id="youtube" name="tab_item" type="radio" />
        <label class="youtube tab_item" for="youtube" @click="changeSns(2)"
          >YouTube</label
        >
        <input id="x" name="tab_item" type="radio" />
        <label class="x tab_item" for="x" @click="changeSns(3)">X</label>
        <span id="slider"></span>
      </div>
    </div>
    <section
      class="container"
      ref="scrollComponent"
      v-on:scroll="loading ? '' : handleScroll()"
    >
      <!-- <div > -->
      <div
        v-masonry="'containerId'"
        item-selector=".item"
        :resize="true"
        v-if="!waitingCount"
        class="card-box"
      >
        <div
          v-masonry-tile
          class="item"
          :key="index"
          :class="['item-' + index]"
          v-for="(item, index) in displayList()"
        >
          <div @click="click(item.id)" class="imgholder">
            <div class="images">
              <img
                :src="item.image"
                class="product-img"
                @load="calcHeight(index)"
                :style="
                  displayLimit &&
                  displayLimit.get(index) &&
                  displayLimit.get(index).limit < 0
                    ? 'filter: brightness(0.7);'
                    : ''
                "
              />
              <!--お気に入りicon-->
              <div class="favorite" @click.stop="updateFavorite(item)">
                <img
                  src="../assets/favorite-icon.svg"
                  :class="[
                    updatedId == item.id && item.is_favorited
                      ? 'update-favorite-icon'
                      : item.is_favorited
                      ? 'favorite-icon'
                      : '',
                  ]"
                />
              </div>
              <div
                v-if="displayLimit.get(index) && displayLimit.get(index).limit != null"
              >
                <div
                  :class="[
                    displayLimit.get(index).limit >= 0 &&
                    displayLimit.get(index).limit <= 5
                      ? 'due'
                      : displayLimit.get(index).limit < 0
                      ? 'closed'
                      : '',
                  ]"
                >
                  <!-- 募集終了まで5日になったら「あと〇〇日」チップ表示する -->
                  <p
                    class="child"
                    v-if="
                      displayLimit.get(index).limit > 0 &&
                      displayLimit.get(index).limit <= 5
                    "
                  >
                    あと{{ displayLimit.get(index).limit }}日
                  </p>
                  <p
                    class="child"
                    v-else-if="
                      displayLimit.get(index).limit == 0
                    "
                  >
                    本日まで
                  </p>
                  <p
                    class="child"
                    v-else-if="displayLimit.get(index).limit < 0"
                  >
                    募集終了
                  </p>
                </div>
              </div>
            </div>
            <p class="p_title">{{ item.title }}</p>
            <p class="price" v-if="!item.is_offer">
              ￥{{ item.outsourcing_amount.toLocaleString() }}
            </p>
            <p v-else class="price" >応相談</p>
            <div class="sns">
              <img :src="mediaIcon" alt="フォロワー以上" />
              <span style="font-weight: 700">
                {{ item.min_follower_count.toLocaleString() }}
              </span>
              <span>フォロワー以上</span>
            </div>
            <div class="capacity">
              <img src="../assets/capacity.svg" alt="募集人数" />
              <span style="font-weight: 700">
                {{ item.recruitment_numbers.toLocaleString() }}
              </span>
              <span>名様</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="loading && !waitingCount"
        :style="hiddenLoading()"
        class="loading"
      >
        <img src="../assets/loading.gif" />
      </div>
    </section>
    <div v-show="waitingCount" class="first-loading">
      <img src="../assets/loading.gif" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { nextTick, onMounted, ref, watch } from "vue";
import Masonry from "masonry-layout";
import { ProjectStore } from "../store/ProjectStore";
import { projects } from "../types/apiResponse";
import { CommonStore } from "../store/CommonStore";
import { MEDIA_ICON, MEDIA_TYPE, rowsPerPage } from "../consts/common";

const commonStore = CommonStore();
const store = ProjectStore();

// eslint-disable-next-line @typescript-eslint/no-require-imports
const mediaIcon = ref(require("../assets/instagram.svg"));

const loading = ref(true);
const initDisplay = ref([true, true, true, true]);
const infiteScroll = ref([false, false, false, false]);
const waitingCount = ref(0);
const clickedSns = ref([commonStore.getMediaId]);
const router = useRouter();
const tabchanged = ref(false);
const isMounted = ref(true);
const updatedId = ref(0);
const updatingFavorite = ref(false);

const displayLimit = ref(new Map());

const scrollComponent = ref<HTMLInputElement>();
const pageNum = ref(store.projectListPageNum[commonStore.getMediaId]);

const hiddenLoading = () => {
  if (!loading.value && waitingCount.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const click = async (id: number) => {
  store.setSelectedId(id);
  router.push("/project-detail");
  setScrollHeight(commonStore.getMediaId);
};

const getScrollHeight = (): number => {
  if (initDisplay.value[commonStore.getMediaId]) {
    return 0;
  }
  switch (commonStore.getMediaId) {
    case MEDIA_TYPE.INSTAGRAM:
      return commonStore.getInstagramScrollHeight;
    case MEDIA_TYPE.TIKTOK:
      return commonStore.getTiktokScrollHeight;
    case MEDIA_TYPE.YOUTUBE:
      return commonStore.getYoutubeScrollHeight;
    case MEDIA_TYPE.X:
      return commonStore.getXScrollHeight;
    default:
      return 0;
  }
};

function displayList() {
  resize();
  return store.activeProjectList?.get(commonStore.getMediaId) || [];
}

function setScrollHeight(currentMediaId: number) {
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (!container || !container.scrollTop) return;
  if (initDisplay.value[commonStore.getMediaId]) return;
  switch (currentMediaId) {
    case MEDIA_TYPE.INSTAGRAM:
      commonStore.setInstagramScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.TIKTOK:
      commonStore.setTiktokScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.YOUTUBE:
      commonStore.setYoutubeScrollHeight(container.scrollTop);
      break;
    case MEDIA_TYPE.X:
      commonStore.setXScrollHeight(container.scrollTop);
      break;
  }
}

async function changeSns(sns: number) {
  updatedId.value = 0;
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  clickedSns.value.push(sns);
  waitingCount.value += 1;
  loading.value = true;
  // 一覧呼び出中はscrollできないようにする
  container.style.overflowY = "hidden";
  commonStore.setMediaId(sns);
  await setDisplay(sns)
    .then(async () => {
      await nextTick(() => {
        if (!displayList()?.length) return;
        if (initDisplay.value[commonStore.getMediaId]) {
          container.scrollTo({
            top: 0,
            behavior: "auto",
          });
          initDisplay.value[sns] = false;
        } else {
          container.scrollTo({
            top: getScrollHeight(),
            behavior: "auto",
          });
        }
      });
      container.style.overflowY = "auto";
    })
    .then(() => {
      mediaIcon.value = setMediaIcon(
        clickedSns.value[clickedSns.value.length - 1]
      );
      isDisplayLimit();
      waitingCount.value -= 1;
      container.style.overflowY = "auto";
    })
    .then(() => {
      loading.value = false;
      tabchanged.value = false;
    });
}

onMounted(async () => {
  document.title = "募集中案件";
  isMounted.value = true;
  waitingCount.value += 1;
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  container.addEventListener("load", resize);
  await setDisplay(commonStore.getMediaId)
    .then(() => {
      waitingCount.value -= 1;
    })
    .then(() => {
      if (initDisplay.value[commonStore.getMediaId]) {
        container.scrollTo({
          top: 0,
          behavior: "auto",
        });
        initDisplay.value[commonStore.getMediaId] = false;
      } else {
        container.scrollTo({
          top: getScrollHeight(),
          behavior: "auto",
        });
      }
      isMounted.value = false;
      // resize();
    });
});
async function handleScroll() {
  // 無限スクロールAPI呼び出し中に上にスクロールした場合のスクロール場所保持
  if (!displayList()?.length) return;
  if (!loading.value) {
    setScrollHeight(commonStore.getMediaId);
  }
  if (store.allCalled[commonStore.getMediaId]) return;
  // 無限スクロールAPI呼び出し中に上にスクロールした場合のスクロール場所保持
  if (loading.value && infiteScroll.value[commonStore.getMediaId]) {
    setScrollHeight(commonStore.getMediaId);
    return;
  }
  // ↑以外API呼び出し中は処理しない
  if (loading.value || waitingCount.value) return;

  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (initDisplay.value[commonStore.getMediaId]) {
    container.style.top = 30 + "px";
    initDisplay.value[commonStore.getMediaId] = false;
  }
  initDisplay.value[commonStore.getMediaId] = false;
  if (!displayList().length) return;

  const element = scrollComponent.value;
  if (!element) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    1
  )
    return;
  if (
    displayList().length <
    store.projectListPageNum[commonStore.getMediaId] * rowsPerPage
  )
    return;
  loading.value = true;
  pageNum.value = store.projectListPageNum[commonStore.getMediaId] + 1;
  store.setProjectListPageNum(pageNum.value, commonStore.getMediaId);
  // 無限スクロール確認 start
  infiteScroll.value[commonStore.getMediaId] = true;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const confirmScroll: any = (await store.getApi(commonStore.getMediaId)) || [];
  if (confirmScroll.length) infiteScroll.value[commonStore.getMediaId] = false;
  // 無限スクロール確認 end

  // スクロールした追加分も「あと〇〇日」の表示有無セット
  isDisplayLimit();
  // pageNum.value += 1;
  container.style.overflowY = "auto";

  const currentHeight = getScrollHeight();
  if (!container) return;

  container.scrollTo({
    top: currentHeight,
    behavior: "auto",
  });

  loading.value = false;
  // }
}

async function calcHeight(index: number) {
  // if (initLoading.value) return
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;

  // if (!index) {
  if (!container) return;
  resize();
  if (displayList() && index != displayList().length - 1) return;

  if (!displayList().length) return;

  const currentHeight = getScrollHeight();
  if (!container) return;

  container.scrollTo({
    top: currentHeight,
    behavior: "auto",
  });

  const lastItem = document.getElementsByClassName(
    `item-${displayList().length - 1}`
  )[0] as HTMLElement;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  if (!lastItem) return;
  initLoading.style.top =
    lastItem.offsetTop + lastItem.scrollHeight - 50 + "px";
}
function resize() {
  const container = document.getElementsByClassName(
    "container"
  )[0] as HTMLElement;
  if (!container) return;
  new Masonry(container, {
    itemSelector: ".item",
  });
}

watch(waitingCount, () => {
  if (waitingCount.value == 0) {
    commonStore.setMediaId(clickedSns.value[clickedSns.value.length - 1]);
    const elements = document.getElementsByName(
      "tab_item"
    ) as NodeListOf<HTMLInputElement>;
    if (elements[commonStore.getMediaId])
      elements[commonStore.getMediaId].checked = true;
    calcHeight(1);
  }
});

const isDisplayLimit = () => {
  if (!displayList().length) {
    return;
  }
  displayList()?.forEach((v, i) => {
    // 日付に変換する
    const dueDate = new Date(v.entry_ended_at);
    const today = new Date(new Date().toDateString());
    const limit = Math.floor((dueDate.getTime() - today.getTime()) / (24 * 60 * 60 * 1000))
    // 管理画面側で00:00締切で登録されるため表示されるチップは−1日で表示する
    displayLimit.value.set(i, { id: v.id, limit: limit -1 });
  });

  loading.value = false;
};

function setMediaIcon(mediaId: number) {
  return MEDIA_ICON[mediaId];
}

// 初期表示 || タブ切り替え時
const setDisplay = async (mediaId: number) => {
  //
  if (!store.activeProjectList) {
    loading.value = true;
    await store.getApi(mediaId);
    initDisplay.value[mediaId] = true;
    mediaIcon.value = setMediaIcon(mediaId);
    // isDisplayLimit();
  } else {
    if (store.activeProjectList.get(mediaId)?.length) {
      loading.value = true;
      initDisplay.value[mediaId] = false;
      mediaIcon.value = setMediaIcon(mediaId);
      // isDisplayLimit();
    } else {
      await store.getApi(mediaId);
      initDisplay.value[mediaId] = true;
      mediaIcon.value = setMediaIcon(mediaId);
      // isDisplayLimit();
    }
  }
  if (displayList().length) {
    // DOM更新まつ
    await nextTick();
    mediaIcon.value = setMediaIcon(mediaId);
    isDisplayLimit();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    displayList().forEach((v: any, index: number) => {
      calcHeight(index);
    });
  }

  // loading.value = false;
};

// お気に入り追加解除
async function updateFavorite(item: projects) {
  if (updatingFavorite.value) return;
  updatingFavorite.value = true;
  if (item.is_favorited) {
    const result = await store.deleteFavoriteProject(item.id);
    if (result) {
      store.updateActiveProject(item, commonStore._mediaId, false);
    }
  } else {
    const result = await store.addFavoriteProject(item);
    if (result) {
      store.updateActiveProject(item, commonStore._mediaId, true);
      updatedId.value = item.id;
    }
  }
  updatingFavorite.value = false;
}
</script>

<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";
.publicsolicitation {
  height: 100%;
}
.publicsolicitation-contents {
  width: 100%;
  height: 100%;
}
#header {
  position: sticky;
  top: 10px;
}
.logo {
  @include logo();
}
.container {
  width: 100%;
  top: 30px;
  min-height: calc(100% - 125px);
  overflow-y: auto;
  overscroll-behavior-y: contain;
  scrollbar-width: none;
  max-height: calc(100% - 125px);
}
.container::-webkit-scrollbar {
  display: none;
}
.tab_item {
  border-radius: 100px;
}

#mediums input:checked + .tab_item {
  color: $white;
  z-index: 99;
}
.instagram {
  @include sns-icon(0%);
}
.tiktok {
  @include sns-icon(25%);
}
.youtube {
  @include sns-icon(50%);
}
.x {
  @include sns-icon(75%);
}
.card {
  background: #f8f8fa;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  img {
    width: 100%;
  }
}
.item {
  background: #f8f8fa;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  width: 48%;
  margin-bottom: 9px;
  margin-right: 5px;
  .product-img {
    width: 100%;
    display: block;
    border-radius: 9px 9px 0 0;
  }

  .images {
    position: relative;
    .due {
      @include tip(#f9d014);
    }
    .closed {
      @include tip(grey);
    }
    .child {
      position: absolute;
      bottom: -9px;
      right: 5px;
      font-style: normal;
      font-weight: 600;
      font-size: $FONT_SIZE_XS;
      line-height: 15px;
      color: #f8f8fa;
    }
    .favorite {
      position: absolute;
      display: flex;
      top: 10px;
      right: 10px;
      width: 33px;
      height: 33px;
      z-index: 99;
      text-align: center;
      align-items: center;
      border-radius: 50%;
      background-color: $white;
      img {
        margin: auto;
      }
      .favorite-icon {
        filter: brightness(0) saturate(100%) invert(51%) sepia(19%)
          saturate(1564%) hue-rotate(162deg) brightness(92%) contrast(87%);
      }
      .update-favorite-icon {
        filter: brightness(0) saturate(100%) invert(51%) sepia(19%)
          saturate(1564%) hue-rotate(162deg) brightness(92%) contrast(87%);
        transform-origin: center bottom;
        animation: bounce 0.8s linear 0s 1;
      }
    }
  }
}
@keyframes bounce {
  0% {
    transform: scale(1, 1) translate(0%, 0%);
  }
  15% {
    transform: scale(0.9, 0.9) translate(0%, 5%);
  }
  30% {
    transform: scale(1.3, 0.8) translate(0%, 10%);
  }
  50% {
    transform: scale(0.8, 1.3) translate(0%, -10%);
  }
  70% {
    transform: scale(1.1, 0.9) translate(0%, 5%);
  }
  100% {
    transform: scale(1, 1) translate(0%, 0%);
  }
}
.card-box {
  height: 100%;
  margin-left: 13px;
  margin-right: 8px;
  .p_title {
    margin-left: 10px;
    margin-right: 8px;
    font-style: normal;
    font-weight: 300;
    font-size: $FONT_SIZE_S;
    line-height: 18px;
    color: #030403;
    overflow-y: hidden;
    @include line-clamp(3);
  }
  .price {
    font-style: normal;
    margin-bottom: 5px;
    font-weight: 700;
    font-size: $FONT_SIZE_M;
    line-height: 21px;
    text-align: left;
    margin-left: 10px;
    color: #333333;
  }
}

.card-box ::-webkit-scrollbar {
  display: none;
}
.imgholder {
  margin-bottom: 12px;
}
.item-holder {
  position: relative;
}
.sns {
  text-align: left;
  padding-left: 11px;
  height: 18px;
  display: flex;
  align-items: center;
  img {
    @include img(11px, 4px);
    filter: brightness(0) saturate(100%) invert(43%) sepia(5%) saturate(13%)
      hue-rotate(333deg) brightness(100%) contrast(91%);
  }
  span {
    @include span(#616161);
  }
}
.capacity {
  text-align: left;
  padding-left: 11px;
  height: 20px;
  display: flex;
  align-items: center;
  img {
    @include img(11px, 4px);
  }
  span {
    @include span($OMOT_COLOR);
  }
}

#mediums {
  position: relative;
  width: 341px;
  margin: auto;
  height: 40px;
  background-color: $grey;
  border-radius: 90px;
}
input[type="radio"] {
  @include radio();
}
label {
  float: left;
  width: 15%;
  margin: 0 0;
  border-radius: 50%;
  cursor: pointer;
}
#slider {
  position: absolute;
  left: 0%;
  top: 0;
  width: 85.25px;
  height: 40px;
  margin: 0 0 0 0;
  background: $OMOT_COLOR;
  transition: transform 0.2s;
  border-radius: 100px;
  animation-timing-function: ease-in-out;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  transition: 0.2s left ease-in-out;
}
#instagram:checked ~ #slider {
  animation-name: instagram;
  left: 0;
}
#tiktok:checked ~ #slider {
  animation-name: tiktok;
  left: 25%;
}
#youtube:checked ~ #slider {
  animation-name: youtube;
  left: 50%;
}
#x:checked ~ #slider {
  animation-name: x;
  left: 75%;
}

.infinite-loading {
  width: 96%;
  // display: flex;
  // position: relative;
  text-align: center;
  img {
    width: 10%;
    height: 10%;
  }
}
.loading {
  display: flex;
  position: absolute;
  justify-content: center;
  img {
    width: 10%;
    height: 10%;
  }
}
.first-loading {
  display: flex;
  width: 96%;
  max-width: 460px;
  position: fixed;
  justify-content: center;
  top: 50%;
  img {
    width: 10%;
    height: 10%;
  }
}
</style>
